import React from 'react'
import { useInView } from 'react-intersection-observer'
import slugify from 'slugify'

import transformLink from '../../utils/transformLink'

import ButtonArrow from '../buttonArrow'
import Wysiwyg from '../wysiwyg'

import roundShape from '../../icons/round-shape.svg'
import semiroundShape from '../../icons/semiround-shape.svg'

const TextFull = ({data, isOffer, fromSimulator = false}) => {
  const { ref, inView} = useInView({ threshold: 0.01, triggerOnce: true})
  const content = data.content

  let cta = null
  
  if (data.cta !== null && data.cta !== undefined) {
    cta = (data.cta.fields) ? data.cta.fields : data.cta
  }

  const {url, contentTypeContentful} = transformLink(cta, true, false)
  const hasTitle = data.displayTitle === undefined || data.displayTitle === null || data.displayTitle

  return (
    <div ref={ref} className={`row text-full ${fromSimulator ? 'text-full--sim' : '' } ${data.switchDecoPlacement ? 'is-reversed' : ''} relative ${inView ? 'has-anim' : ''} `} id={slugify(data.title)}>
      { !fromSimulator &&
        <>
          <svg className="icon-aqua text-full__semiround absolute" width="136" height="145">
            <use xlinkHref={semiroundShape.url} />
          </svg>

          <svg className="icon-night text-full__round absolute" width="64" height="64">
            <use xlinkHref={roundShape.url} />
          </svg>

          <svg className="icon-sienne text-full__round2 absolute" width="105" height="105">
            <use xlinkHref={roundShape.url} />
          </svg>
        </>
      }

      <div className={`col-12 ${isOffer ? 'lg-col-7' : 'lg-col-8' } mx-auto`}>
        { hasTitle &&
          <h2 className={`${fromSimulator ? 'text-orange text-24 font-semibold mb-6' : 'title title-slice mb-5 md:mb-6'} scroll-anim-el`}>{ data.title }</h2>
        }
        
        <div className={`scroll-anim-el ${hasTitle ? 'scroll-anim-el--2' : '' }`}>
          <Wysiwyg
            isOffer={isOffer} 
            document={content} 
            hasTitle={hasTitle} />
          
          { cta !== null &&
            <div className="mt-6 lg:mt-8">
              <ButtonArrow text={ cta.label } link={url} contentType={contentTypeContentful} color="night" />
            </div>
          }
        </div>
      </div>
    </div>
  )
}


export default TextFull
